import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "LoadingWrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "LoadingContent" }, [
      _createElementVNode("img", {
        class: "LoadingAnimation",
        src: "https://monet-prtl-co.imgix.net/Endor/ERT/loading-indicator-globe.svg",
        alt: "Loading ..."
      }),
      _createElementVNode("span", { class: "LoadingText" }, " Loading your qualified enrolments. ")
    ], -1 /* CACHED */)
  ]))]))
}